// Compile each authoring page when its route is first opened.
export const deferredWorkspacePages = new Set([
    'page.admin', 'page.sources', 'page.datasets', 'page.dpo', 'page.knowledge_graph', 'page.knowledge_map'
]);
type PageModuleFactory = (id: string, route: any) => any;
let pageModuleFactory: PageModuleFactory | null = null;
export function registerWorkspacePages(factory: PageModuleFactory) { pageModuleFactory = factory; }
export function loadWorkspacePage(id: string, route: any) {
    if (!pageModuleFactory) throw new Error('작업 화면을 준비하지 못했습니다. 새로고침해 주세요.');
    return pageModuleFactory(id, route);
}
